import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    makeStyles,
    DialogTitle,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Button,
    InputAdornment,
    Divider
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import * as logger from '../../../logger';
import { getInsuranceProviders, addNewInsuranceProvider, editElr } from '../../../store/actions/tripActionCreator';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { capitalizeTheWord, replaceCommas } from '../../../utils/utils';
import AddIcon from '@material-ui/icons/Add';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AmountInput from '../Inputs/AmountInput';
import TextInputState from '../Inputs/TextInputState';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';

const useStyles = makeStyles((theme) => ({
    dialogTitleV1: {
        paddingLeft: 30,
        paddingRight: 18,
        paddingTop: 14,
        paddingBottom: '14px !important',
        '& .MuiTypography-root': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    },
    closeButton: {
        color: '#9ea0a5'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 500
    },
    paper1: {
        borderRadius: 8
    },
    paperWidth: {
        width: 460,
        maxWidth: 460
    },
    dialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 24,
        paddingBottom: 24
    },
    daV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 21,
        paddingBottom: 21
    },
    divTitleV1: {
        color: '#6b778c',
        fontSize: 12
    },
    textFieldV1: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px',
            textTransform: 'uppercase'
        }
    },
    mtV1: {
        marginTop: 16
    },
    riskTypeRadio: {
        maxWidth: '100% !important',
        marginTop: 16,
        '& .MuiFormControl-fullWidth': {
            //maxWidth:'100% !important'
        },
        '& .MuiFormControlLabel-root': {
            //marginRight:0
        },
        '& .MuiRadio-root': {
            //display:'none'
        },
        '& .MuiFormLabel-root': {
            fontSize: 12,
            marginBottom: 8,
            color: '#6b778c',
        }
    },
    riskTypeLabel: {
        //height: 36,
        //padding: '6px 12px',
        borderRadius: 8,
        marginRight: 6,
        marginLeft: 0,
        backgroundColor: '#e4e4e4',
        '& .MuiButtonBase-root': {
            display: 'none'
        },
        '& .MuiTypography-root': {
            fontSize: 14,
            padding: '12px 14px',
            borderRadius: 8,
            backgroundColor: '#e4e4e4',
            color: '#6b778c',
            padding: '8px 12px',
            fontWeight: 300,
        },
        '& span.Mui-checked+span': {
            color: '#e86825',
            fontWeight: 300,
            backgroundColor: '#f9e6b5',
            // letterSpacing: '1px',
            border: '1px solid #e86825',
            paddingTop: 7,
            paddingBottom: 7,
            paddingLeft: 11,
            paddingRight: 11,
            fontSize: 14,
        }
    },
    autoCompleteV1: {
        paddingBottom: '4px !important',
        paddingTop: '4px !important'
    },
    closeButtonV1: {
        borderRadius: 4,
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingLeft: 19.5,
        paddingRight: 19.5,
        paddingTop: 7,
        paddingBottom: 7,
        backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important',
        marginRight: 16,
        '&:hover': {
            backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important'
        }
    },
    confirmButton: {
        borderRadius: 4,
        backgroundColor: '#5170f0',
        color: 'white',
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 35,
        paddingRight: 35,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    divAlignV4: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    },
    divV2: {
        display: 'flex'
    },
    addIcon: {
        fontSize: 18,
        color: '#0033cc'
    },
    divV3: {
        color: '#0033cc',
        display: 'flex'
    },
    cherveRightIcon: {
        color: '#0033cc',
        fontSize: 20
    },
    divListItem: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 14,
        paddingRight: 14,
        fontSize: 14,
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0
    },
    listBoxOption: {
        padding: 0,
        minHeight: 46,
        maxHeight: 46,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    textFieldV2: {
        '& .MuiInputBase-input': {
            textTransform: 'capitalize'
        }
    },
    eventIcon: {
        color: 'grey'
    }
}));

const filter = createFilterOptions({
    limit: 30
});

const AddInsuranceDialog = ({ open, onClose, onConfirm, edit, trip, user, insuranceData, dispatchGetInsuranceProviders, dispatchAddNewInsuranceProvider, dispatchEditElr }) => {

    let submit;

    const classes = useStyles();

    const [dialogOpen, setDialogOpen] = useState(open);
    const [insuredAmountValue, setInsuredAmountValue] = useState("");
    const [insuranceProvider, setInsuranceProvider] = useState("");
    const [insurancePolicyNumber, setInsurancePolicyNumber] = useState("");
    const [insuredDate, setInsuredDate] = useState("");
    const [riskTypeValue, setRiskTypeValue] = useState("");

    const elrId = user && user.singleTripData && user.singleTripData.elr_id ? user.singleTripData.elr_id : ""

    const initialValues = {
        insuredValue: insuredAmountValue,
        provider: insuranceProvider,
        policyNumber: insurancePolicyNumber,
        insuredOn: insuredDate,
        riskType: riskTypeValue
    }

    useEffect(() => {

        const regExp = /[a-zA-Z]/g;

        if (open) {

            dispatchGetInsuranceProviders(
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Add Insurance Dialog Dweb", "Get Insurance Providers Successfull");
                    }
                },
                () => {
                    logger.log("Add Insurance Dialog Dweb", "Get Insurance Providers Failed");
                }
            )

        }

        if (edit && insuranceData) {
            setInsuredAmountValue(insuranceData.insured_value);
            setInsuranceProvider(insuranceData.provider);
            setInsurancePolicyNumber(insuranceData.policy_number);
            setInsuredDate(regExp.test(insuranceData.insured_on) ? (Math.round((insuranceData.insured_on.getTime()) / 1000)).toString() : new Date(insuranceData.insured_on * 1000));
            setRiskTypeValue(insuranceData.risk_type);
        }

    }, [open]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleAddNewProvider = (providerName) => {

        const providerData = {
            name: capitalizeTheWord(providerName).replace(/\"/ig, "")
        }

        dispatchAddNewInsuranceProvider(providerData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Add Insurance Dialog Dweb', 'Add new insurance provider successfull');
                    dispatchGetInsuranceProviders(
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Add Insurance Dialog Dweb", "Get Insurance Providers Successfull");
                            }
                        },
                        () => {
                            logger.log("Add Insurance Dialog Dweb", "Get Insurance Providers Failed");
                        }
                    )
                }
            },
            () => {
                logger.log('Add Insurance Dialog Dweb', 'Add new insurance provider failed');
            }
        )

    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <div className={classes.divTitleV1}>Insurance Provider</div>
                            {trip && trip.insuranceProvidersList && (trip.insuranceProvidersList.length > 0 || !insuranceProvider) &&
                                <Autocomplete
                                    classes={{
                                        listbox: classes.listBoxAutoCompelete,
                                        option: classes.listBoxOption,
                                        inputRoot: classes.autoCompleteV1
                                    }}
                                    id="select-provider-list"
                                    name="provider"
                                    size="small"
                                    placeholder="Insurance Provider"
                                    className={classes.textFieldV2}
                                    autoHighlight
                                    options={trip && trip.insuranceProvidersList ? trip.insuranceProvidersList : []}
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    getOptionValue={option => option.name}
                                    getOptionLabel={(option) => {
                                        // if (typeof option === 'string') {
                                        //     return '';
                                        // }
                                        // if (option.inputValue || !option.id) {
                                        //     return '';
                                        // }
                                        setInsuranceProvider(option.name.replace(/\"/ig, ""))
                                        return option.name.replace(/\"/ig, "")
                                    }}
                                    disableCloseOnSelect={false}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        if (params.inputValue !== '') {
                                            filtered.unshift({
                                                inputValue: params.inputValue,
                                                name: `"${capitalizeTheWord(params.inputValue)}"`,
                                            });
                                        }
                                        return filtered;
                                    }}
                                    renderOption={(option, { selected, inputValue }) => {
                                        let matchesName;
                                        let partsName;
                                        matchesName = match(option.name, inputValue);
                                        partsName = parse(option.name, matchesName);

                                        if (option && option.id) {
                                            return (
                                                <>
                                                    <div className={classes.divListItem}>
                                                        {partsName.map((part, index) => {
                                                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                                                {part.text}
                                                            </span>
                                                            )
                                                        })}
                                                    </div>
                                                </>
                                            );

                                        } else {
                                            return (
                                                <div className={classes.divAlignV4} onClick={() => handleAddNewProvider(option.name.toString())}>
                                                    <div className={classes.divV2}>
                                                        <div>
                                                            <AddIcon className={classes.addIcon} />
                                                        </div>
                                                        <div className={classes.divV3}>
                                                            <div className={classes.divV5}>Tap to add provider &nbsp;&nbsp;</div>

                                                            <span className={classes.divV4} >
                                                                {partsName.map((part, index) => {
                                                                    return (<span key={index} style={{ color: '#0033cc' }}>
                                                                        {part.text}
                                                                    </span>
                                                                    )
                                                                })}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ChevronRightIcon className={classes.cherveRightIcon} />
                                                </div>
                                            );
                                        }

                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Insurance Provider"
                                            variant="outlined"
                                            name={"provider"}
                                            margin='normal'
                                            style={{ margin: 0, marginTop: 6 }}
                                        />
                                    )}
                                    multiple={false}
                                />
                            }
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Insurance Policy Number</div>
                            <TextInputState
                                placeholder="Insurance Policy Number"
                                name="policyNumber"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV1}
                                onChange={(e) => setInsurancePolicyNumber(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Insured On</div>
                            <DatePicker
                                name="insuredOn"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Insured On"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.textFieldV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                onChange={(date) => { setInsuredDate(date) }}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <Radios
                                label="Risk Type"
                                name="riskType"
                                required={true}
                                formControlProps={{
                                    margin: 'none',
                                    className: classes.riskTypeRadio,
                                    fullWidth: true
                                }}
                                formControlLabelProps={{
                                    className: classes.riskTypeLabel
                                }}
                                radioGroupProps={{ row: true }}
                                data={[
                                    { value: 'High', label: 'High' },
                                    { value: 'Low', label: 'Low' },
                                ]}
                                onChange={(e) => { setRiskTypeValue(e.target.value) }}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Insured Value</div>
                            <AmountInput
                                placeholder="Insured Value"
                                name="insuredValue"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setInsuredAmountValue(e.target.value)}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">&#x20b9;</InputAdornment>
                                }}
                                className={classes.textFieldV1}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const validate = values => {

        const errors = {};

        if (values && !values.provider) {
            errors.provider = "Please select insurance provider.";
        }
        if (values && !values.insuredOn) {
            errors.insuredOn = "Please select date"
        }
        if (values && !values.riskType) {
            errors.riskType = "Please select risk type"
        }
        if (values && !values.insuredValue) {
            errors.insuredValue = "Please enter insured value."
        }

        return errors;

    }

    const onSubmit = values => {

        const regExp = /[a-zA-Z]/g;

        const insuranceData = {
            insurance_details: {
                insured_on: regExp.test(values.insuredOn) ? Math.round((values.insuredOn.getTime()) / 1000) : values.insuredOn,
                insured_value: values.insuredValue ? replaceCommas(values.insuredValue) : "",
                policy_number: values.policyNumber ? values.policyNumber.toUpperCase() : "",
                provider: values.provider ? capitalizeTheWord(values.provider) : "",
                risk_type: values.riskType ? values.riskType : "",
            }
        }

        setDialogOpen(false);
        onConfirm(insuranceData);

        // dispatchEditElr(
        //     elrId,
        //     insuranceData,
        //     (data) => {
        //         if (data && data.status && data.status.code == 200) {
        //             logger.log('Add Insurance Dialog Dweb', 'Edit Elr Insurance Successfull');
        //             setDialogOpen(false);
        //             onConfirm(insuranceData);
        //         }
        //     },
        //     () => {
        //         logger.log('Add Insurance Dialog Dweb', 'Edit Elr Insurance Failed');
        //     }
        // )

    }

    return (
        <>
            <Dialog fullWidth={true} maxWidth={'sm'}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} open={dialogOpen} classes={{ paper: classes.paper1, paperWidthSm: classes.paperWidth }}>

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divTitle}>
                        {!edit &&
                            "Add Insurance Policy Details"
                        }
                        {edit &&
                            "Edit Insurance Policy Details"
                        }
                    </div>
                    <IconButton onClick={() => { handleClose() }} className={classes.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>
                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>

                <DialogActions className={classes.daV1}>
                    <Button variant="contained" className={classes.closeButtonV1} onClick={() => { handleClose() }}>
                        Close
                    </Button>
                    <Button variant="contained" className={classes.confirmButton} type="submit"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetInsuranceProviders: (onSuccess, onError) => {
        dispatch(getInsuranceProviders(onSuccess, onError))
    },
    dispatchAddNewInsuranceProvider: (providerData, onSuccess, onError) => {
        dispatch(addNewInsuranceProvider(providerData, onSuccess, onError))
    },
    dispatchEditElr: (elrId, insuranceData, onSuccess, onError) => {
        dispatch(editElr(elrId, insuranceData, onSuccess, onError))
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(AddInsuranceDialog);